
import React from "react";

interface MentorFormProgressProps {
  step: number;
  totalSteps: number;
}

const MentorFormProgress: React.FC<MentorFormProgressProps> = ({ step, totalSteps }) => {
  const stepLabels = [
    "Personal Information",
    "About You",
    "Review & Submit"
  ];

  const progress = (step / totalSteps) * 100;

  return (
    <div>
      <div className="flex justify-between mb-2">
        <span className="text-sm font-medium">Step {step} of {totalSteps}</span>
        <span className="text-sm font-medium">{Math.round(progress)}% Complete</span>
      </div>
      
      <div className="h-2 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full bg-primary transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
      
      <div className="mt-6 grid grid-cols-3 gap-2">
        {stepLabels.map((label, index) => (
          <div
            key={index}
            className={`text-center ${
              index + 1 === step
                ? "text-primary font-medium"
                : index + 1 < step
                ? "text-muted-foreground"
                : "text-muted-foreground/50"
            }`}
          >
            <div
              className={`w-8 h-8 mx-auto flex items-center justify-center rounded-full mb-2 ${
                index + 1 === step
                  ? "bg-primary text-primary-foreground"
                  : index + 1 < step
                  ? "bg-primary/20 text-primary"
                  : "bg-muted text-muted-foreground"
              }`}
            >
              {index + 1 < step ? (
                "✓"
              ) : (
                index + 1
              )}
            </div>
            <span className="text-xs hidden md:block">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MentorFormProgress;
